var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalRequests(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2551_2716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.74707 17.9443C7.62085 17.2639 8.18445 16.203 8.18445 15.0125C8.18445 12.9637 6.51746 11.2969 4.46869 11.2969C2.41992 11.2969 0.753113 12.9637 0.753113 15.0125C0.753113 16.203 1.31671 17.2639 2.19031 17.9443C0.957275 18.6779 0 20.0632 0 21.7906V23.2969C0 23.6852 0.314758 24 0.703125 24H8.23444C8.62262 24 8.93756 23.6852 8.93756 23.2969V21.7906C8.93756 20.0636 7.98047 18.678 6.74707 17.9443ZM2.15936 15.0125C2.15936 13.7391 3.19537 12.7031 4.46887 12.7031C5.74219 12.7031 6.7782 13.7391 6.7782 15.0125C6.7782 16.2859 5.74219 17.322 4.46887 17.322C3.19537 17.322 2.15936 16.2859 2.15936 15.0125ZM7.53131 22.5938H1.40625V21.7906C1.40625 20.0991 2.77478 18.7282 4.46869 18.7282C6.16022 18.7282 7.53113 20.0967 7.53113 21.7906V22.5938H7.53131Z",
    fill: "#667085"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0376 0H12.0001C10.3638 0 9.0376 1.32385 9.0376 2.96246V16.5187C9.0376 17.0938 9.69714 17.4302 10.1626 17.0812L12.9875 14.9625H21.0376C22.6738 14.9625 24.0001 13.6386 24.0001 12V2.96246C24.0001 1.32623 22.6762 0 21.0376 0ZM22.5938 12C22.5938 12.8602 21.8982 13.5562 21.0376 13.5562H12.7532C12.601 13.5562 12.4531 13.6057 12.3313 13.6968L10.4438 15.1124V2.96246C10.4438 2.10223 11.1395 1.40625 12.0001 1.40625H21.0376C21.8978 1.40625 22.5938 2.10187 22.5938 2.96246V12Z",
    fill: "#667085"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2842 3.76562H12.7529C12.3646 3.76562 12.0498 4.08057 12.0498 4.46875C12.0498 4.85712 12.3646 5.17188 12.7529 5.17188H20.2842C20.6724 5.17188 20.9874 4.85712 20.9874 4.46875C20.9874 4.08057 20.6726 3.76562 20.2842 3.76562Z",
    fill: "#667085"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2842 6.77832H12.7529C12.3646 6.77832 12.0498 7.09308 12.0498 7.48145C12.0498 7.86963 12.3646 8.18457 12.7529 8.18457H20.2842C20.6724 8.18457 20.9874 7.86963 20.9874 7.48145C20.9874 7.09308 20.6726 6.77832 20.2842 6.77832Z",
    fill: "#667085"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5185 9.79053H12.7529C12.3646 9.79053 12.0498 10.1053 12.0498 10.4937C12.0498 10.882 12.3646 11.1968 12.7529 11.1968H16.5185C16.9069 11.1968 17.2216 10.882 17.2216 10.4937C17.2216 10.1053 16.9069 9.79053 16.5185 9.79053Z",
    fill: "#667085"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2551_2716"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalRequests);
export default __webpack_public_path__ + "static/media/totalRequests.a0cc5e62421d6f182f1ef25171889f26.svg";
export { ForwardRef as ReactComponent };